export const ICONGRAPHY = {
  size: {
    xs: 8,
    sm: 12,
    md: 16,
    lg: 18,
    xl: 24,
    "2xl": 32,
  },
};
